import React from 'react';
import { Modal } from 'antd';
import Swal from 'sweetalert2';
import Lottie from 'react-lottie-player/dist/LottiePlayerLight';
import { LoadingOutlined } from '@ant-design/icons';
import animation from '../animations/lottie/Planeaciones.json';

// eslint-disable-next-line import/prefer-default-export
export const catchRequest = (err, dispatch) => {
    // eslint-disable-next-line no-console
    console.error(err);
    if (err?.message === 'Network Error') {
        Swal.fire(
            'Error de red',
            'Por favor verifique su conexión a internet',
            'error',
        );
    } else {
        // eslint-disable-next-line no-restricted-syntax
        if ('message' in err && !err.message) return; // if request was canceled by user (axios cancelToken)

        if (err.response?.status === 401) {
            Swal.fire(
                'No Autorizado (401)',
                'Está intentando acceder a un recurso ajeno a usted.',
                'error',
            ).then((result) => {
                result && window.location.replace('/');
            });
        } else if (err.response?.status === 403) {
            Swal.fire(
                '¡Lo sentimos!',
                'La sesión ha expirado.',
                'info',
            ).then((result) => {
                result && dispatch({ type: 'DELETE_USER_INFO' });
            });
        } else if (err.response?.status === 406) {
            Swal.fire(
                'Acceso denegado',
                'No es posible acceder al buzón digital desde fuera de México. Si está usando una VPN por favor deshabilítela.',
                'info',
            );
        } else if (err.response?.status === 408) {
            Swal.fire(
                '¡La conexión tardó demasiado en responder!',
                'Actualiza la página y revisa tu conexión a internet.',
                'error',
            );
        } else if (err.response?.status === 423) {
            Swal.fire(
                'Demasiados intentos',
                'Ha realizado muchos intentos fallidos de inicio de sesión. El usuario se ha bloqueado. Por favor intente de nuevo en 15 minutos',
                'error',
            );
        } else if (err.response?.status === 429) {
            Swal.fire(
                'Recurso bloqueado',
                'Este servicio está bloqueado a cierto número de solicitudes mensuales, por favor, contacte al administrador. ',
                'info',
            );
        } else if (err.response?.status === 470) {
            const modal = Modal.info({
                title: <span style={{ fontSize: '20px' }}>Lo sentimos</span>,
                icon: <LoadingOutlined />,
                content: <div style={{ marginLeft: '-35px' }}>
                    <div className="d-flex flex-column ">
                        <div className="d-flex flex-row justify-content-center">
                            <span>
                                Ha ocurrido un error al obtener los datos del SACCG, espere un momento la página se recargará automaticamente.
                            </span>
                        </div>
                        <Lottie
                            className="m-0 p-0"
                            loop
                            animationData={animation}
                            play
                        />
                    </div>
                </div>,
                centered: true,
                okButtonProps: { hidden: true },
                cancelButtonProps: { hidden: true },
            });

            setTimeout(() => {
                modal.destroy();
                window.location.reload();
            }, 120000);
        } else {
            Swal.fire(
                '¡Lo sentimos!',
                'Ha ocurrido un error, actualice la página y si el error persiste, contacte al administrador.',
                'error',
            );
        }
    }
};
